(function () {
  // Cloche de l'en-tête : ouvre le panneau des notifications. La pastille « 1 »
  // disparaît une fois le panneau ouvert (mémorisé par navigateur).
  var root = document.querySelector('[data-notif]');
  if (!root) return;
  var toggle = root.querySelector('[data-notif-toggle]');
  var panel = root.querySelector('[data-notif-panel]');
  var count = root.querySelector('[data-notif-count]');
  var link = root.querySelector('[data-notif-newsletter]');
  var seenKey = 'namourou-notif-seen:' + (link ? link.textContent.trim() : '');

  function seen() { try { return localStorage.getItem(seenKey) === '1'; } catch (e) { return false; } }
  function markSeen() {
    count.hidden = true;
    toggle.setAttribute('aria-label', 'Notifications');
    try { localStorage.setItem(seenKey, '1'); } catch (e) {}
  }
  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) markSeen();
  }
  if (seen()) markSeen();

  toggle.addEventListener('click', function () { setOpen(panel.hidden); });
  document.addEventListener('click', function (event) {
    if (!panel.hidden && !root.contains(event.target)) setOpen(false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
  });

  // Clic sur la notification : ouvre le popup Klaviyo. Si Klaviyo n'est pas chargé
  // (bloqueur de pub, cookies refusés), le lien descend vers le formulaire du pied de page.
  if (link) link.addEventListener('click', function (event) {
    var formId = link.getAttribute('data-notif-newsletter');
    setOpen(false);
    // Une fois Klaviyo chargé, il remplace la méthode push de la file _klOnsite.
    if (!formId || !window._klOnsite || window._klOnsite.push === Array.prototype.push) return;
    event.preventDefault();
    window._klOnsite.push(['openForm', formId]);
  });
})();
